import React from "react";
import { Route, Navigate } from "react-router-dom";
import * as Icon from "react-feather";
import { all_routes } from "./all_routes";
import Signin from "../feature-module/pages/login/signin";
import Users from "../feature-module/usermanagement/users";
import Invoices from "../feature-module/invoice";
import CreateInvoice from "../feature-module/invoice/createinvoice";
import UpdateInvoice from "../feature-module/invoice/updateinvoice";
import InvoicePreview from "../feature-module/invoice/invoicepreview";
import Profile from "../feature-module/pages/profile";
import CreateUser from "../feature-module/usermanagement/createuser";
import UpdateUser from "../feature-module/usermanagement/updateuser";
import ForgotPassword from "../feature-module/pages/forgotpassword/forgotpassword";
import ResetPassword from "../feature-module/pages/resetpassword/resetpassword";
import Dashboard from "../feature-module/dashboard";
import AuditLogs from "../feature-module/auditlog";

const routes = all_routes;

export const authRoute = [
  {
    path: routes?.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    path: routes?.forgotPassword,
    name: "forgotPassword",
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes?.resetPassword + '/:token',
    name: "resetpassword",
    element: <ResetPassword />,
    route: Route,
  },
];

export const publicRoutes = [
  {
    label: "Main",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        path: routes?.dashboard,
        icon: <Icon.Grid />,
        element: <Dashboard />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: false,
        permissions: ['All'],
      },
    ],
  },
  {
    label: "Invoice Management",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Invoice Management",
    submenuItems: [
      {
        label: "Invoices",
        path: routes?.invoices,
        icon: <Icon.FileText />,
        element: <Invoices />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: false,
        permissions: ['All'],
      },
      {
        label: "Add Invoice",
        path: routes?.addInvoice,
        icon: <Icon.PlusCircle />,
        element: <CreateInvoice />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: true,
        permissions: ['All'],
      },
      {
        label: "Edit Invoice",
        path: routes?.editInvoice + '/:id',
        icon: <Icon.PlusCircle />,
        element: <UpdateInvoice />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: true,
        permissions: ['All'],
      },
      {
        label: "View Invoice",
        path: routes?.viewInvoice + '/:id',
        icon: <Icon.PlusCircle />,
        element: <InvoicePreview />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: true,
        permissions: ['All'],
      },
    ],
  },
  {
    label: "Audit & Logs",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Audit & Logs",
    submenuItems: [
      {
        label: "Audit Logs",
        path: routes?.auditLogs,
        icon: <Icon.Activity />,
        element: <AuditLogs />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: false,
        permissions: ['All'],
      },
    ],
  },
  {
    label: "User Management",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "User Management",
    submenuItems: [
      {
        label: "Users",
        path: routes?.users,
        icon: <Icon.UserCheck />,
        element: <Users />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: false,
        permissions: ['admin'],
      },
      {
        label: "Add User",
        path: routes?.addUser,
        icon: <Icon.PlusCircle />,
        element: <CreateUser />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: true,
        permissions: ['admin'],
      },
      {
        label: "Edit User",
        path: routes?.editUser + '/:id',
        icon: <Icon.PlusCircle />,
        element: <UpdateUser />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: true,
        permissions: ['admin'],
      },
    ],
  },
  {
    label: "Settings",
    submenu: true,
    showSubRoute: false,
    submenuHdr: "Settings",
    submenuItems: [
      {
        label: "Profile",
        path: routes?.profile,
        icon: <Icon.User />,
        element: <Profile />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: false,
        permissions: ['All'],
      },
      {
        label: "Logout",
        path: routes?.logout,
        icon: <Icon.LogOut />,
        element: <Navigate to={routes?.signin} />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: false,
        permissions: ['All'],
      },
      {
        label: "Not Found",
        path: "*",
        icon: <Icon.LogOut />,
        element: <Navigate to={'/'} />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: true,
        permissions: ['All'],
      },
      {
        label: "Root",
        path: "/",
        icon: <Icon.LogOut />,
        element: <Navigate to={routes.dashboard} />,
        submenu: false,
        showSubRoute: false,
        hideInMenu: true,
        permissions: ['All'],
      },
    ],
  },
];
